import config from "config";
import $ from "jquery";
import Promise from "bluebird";
import ko from "knockout";
import _ from "lodash";
import Upload from "models/Upload";
import requestTracker from "services/activeRequestTracker";
import HttpError from "util/HttpError";
import authClientService from "services/authClientService";

const uploadRoot = config.uploadService.uri;
const activeUploads = ko.observableArray([]);
let oAuthBearerToken;

function updateProgress(progressTracker, progressEvent) {
    if (progressTracker.upload) {
        progressTracker.upload.bytesUploaded(progressEvent.loaded);
        progressTracker.upload.totalBytes(progressEvent.total);
    }
}

function generateFormData(fileData, metadata) {
    const data = new FormData();

    data.append("file", fileData);
    Object.entries(metadata).forEach((entry) => {
        const [key, value] = entry;
        data.append(key, value);
    });

    return data;
}

async function upload(path, fileData, metadata) {
    const url = uploadRoot + path;

    const progressTracker = {};

    // Always try to get fresh token from gc-mfe-auth first when embedded
    const isStandalone = window === window.parent;

    let currentToken = oAuthBearerToken;

    if (!isStandalone) {
        // Try gc-mfe-auth when embedded (not standalone)
        try {
            const freshToken = await authClientService.getToken();
            if (freshToken) {
                currentToken = freshToken;
            }
        } catch (error) {
            // Continue with cached token (currentToken = oAuthBearerToken)
        }
    }

    const headers = {};
    if (currentToken) {
        headers.Authorization = "bearer " + currentToken;
    }

    let progress_xhr;
    const xhr = $.ajax({
        url: url,
        type: "POST",
        headers: headers,
        enctype: "multipart/form-data",
        xhr: function () {
            progress_xhr = new XMLHttpRequest();
            progress_xhr.upload.addEventListener(
                "progress",
                _.bind(updateProgress, null, progressTracker),
                false
            );
            return progress_xhr;
        },
        data: generateFormData(fileData, metadata),
        cache: false,
        processData: false,
        contentType: false,
    });

    const promise = Promise.cast(xhr)
        .cancellable()
        .catch(function (error) {
            if (error.name === "CancellationError") {
                xhr.abort();
                return Promise.reject(error);
            } else {
                // Notify authClientService about 401 response when using gc-mfe-auth token
                if (
                    error.status === 401 &&
                    !isStandalone &&
                    currentToken &&
                    currentToken !== oAuthBearerToken
                ) {
                    authClientService.notify401Response(currentToken);
                }
                return Promise.reject(new HttpError(error));
            }
        })
        .finally(function () {
            activeUploads.remove(progressTracker.upload);
        });

    requestTracker.addRequest(promise);
    progressTracker.upload = new Upload(promise, metadata);

    activeUploads.push(progressTracker.upload);

    return progressTracker.upload;
}

/**
 * File upload service. Handles uploading files with progress
 *
 * Usage:
 *
 * var upload = fileUploadService.post(uploadPath, fileData, fileMetadata)
 *                  .then(function(){
 *                      //upload completed
 *                  })
 *                  .catch(function() {
 *                      //upload error
 *                  });
 *
 * fileData should be of Blob or File type.
 * fileMetadata is optional
 */
export default {
    activeUploads: activeUploads,

    /**
     * Upload a file using POST
     * @param uri
     * @param data
     * @param uploadProgress Model
     */
    upload: function (path, fileData, metadata) {
        return upload(path, fileData, metadata);
    },

    setOauthBearerToken: function (bearerToken) {
        oAuthBearerToken = bearerToken;
    },
};
